import _uniq from "lodash/uniq";
import {registerHtmlHook} from "../utils/htmlHooks";
import eventBus from './event-bus';

function getProductAvailability(productsAvailableElements) {
    if (!productsAvailableElements.length) {
        return;
    }

    const data = {
        products: [],
        quantities: {},
    };

    Array.from(productsAvailableElements).forEach((el, index) => {

        data.products.push(el.dataset.productId);

        if (!data.quantities[el.dataset.productId]) {
            data.quantities[el.dataset.productId] = {};
        }

        data.quantities[el.dataset.productId][index] = el.dataset.quantity ?? '1';
    });

    data.products = _uniq(data.products);

    if (data.products.length > 0) {
        window.axios.post(window.config.urls.products.availability, data)
            .then(({data}) => {
                for(const key in data.availabilityList) {
                    const value = data.availabilityList[key];

                    document.querySelectorAll(`.product-availability-async[data-product-id="${key}"]`).forEach((el, index) => {
                        el.innerHTML = value.display;
                    });
                }
            })
            .catch(error => {
                document.querySelectorAll(`.product-availability-async[data-product-id]`).forEach((el, index) => {
                    el.innerHTML = window.config.language.errorOccurred;
                });
            });
    }
}

const updateProductAvailabilityOnEvent = () => getProductAvailability(document.querySelectorAll('.product-availability-async[data-product-id]'));

window.addEventListener("DOMContentLoaded", updateProductAvailabilityOnEvent);
eventBus.on('cart-item-quantity-change', updateProductAvailabilityOnEvent);

registerHtmlHook(updateProductAvailabilityOnEvent);
